var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButton432(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 91,
    viewBox: "0 0 432 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_bow_button_432",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 12,
    width: 421,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7986 14.1679C75.2884 16.2015 356.09 14.5376 383.6 13.0586C405.952 11.9494 413.785 13.4284 418.561 31.916C421.236 42.2691 419.708 65.9333 417.797 73.6981C415.505 82.3873 408.436 90.337 388.376 89.9672C370.227 89.5975 83.1213 89.4126 35.933 90.7067C3.83725 91.816 3.45516 80.5385 1.73574 74.0678C0.0163301 67.5972 -0.938899 41.3447 1.35365 33.7648C7.27607 15.6469 25.9986 13.4284 38.7986 14.1679Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_bow_button_432)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7986 14.1679C75.2884 16.2015 356.09 14.5376 383.6 13.0586C405.952 11.9494 413.785 13.4284 418.561 31.916C421.236 42.2691 419.708 65.9333 417.797 73.6981C415.505 82.3873 408.436 90.337 388.376 89.9672C370.227 89.5975 83.1213 89.4126 35.933 90.7067C3.83725 91.816 3.45516 80.5385 1.73574 74.0678C0.0163301 67.5972 -0.938899 41.3447 1.35365 33.7648C7.27607 15.6469 25.9986 13.4284 38.7986 14.1679Z",
    fill: "url(#paint0_linear_bow_button_432)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 52.6016L39.9977 13.4754C47.6484 13.8365 63.2675 14.0741 83.8223 14.2122L9.45193 86.9622C3.96599 83.7127 2.89795 79.179 2.05119 75.5846C1.93845 75.106 1.82964 74.6441 1.71484 74.2041C0.804981 70.7167 0.109847 61.568 0 52.6016Z",
    fill: "url(#paint1_linear_bow_button_432)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7034 90.5004C65.0066 90.631 49.2188 90.7956 39.6149 91L117.975 14.3476C131.928 14.3727 146.97 14.3699 162.557 14.3435L84.7034 90.5004Z",
    fill: "url(#paint2_linear_bow_button_432)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.902 90.1774C148.34 90.2143 133.263 90.2613 119.179 90.3196L196.941 14.2513C211.888 14.1973 226.965 14.1256 241.736 14.0397L163.902 90.1774Z",
    fill: "url(#paint3_linear_bow_button_432)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.88 90.0707C228.178 90.0774 213.168 90.091 198.259 90.1125L276.262 13.8089C292.344 13.6867 307.563 13.5494 321.256 13.4022L242.88 90.0707Z",
    fill: "url(#paint4_linear_bow_button_432)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.718 90.1005C308.098 90.0826 293.048 90.0709 277.174 90.067L356.005 12.9537C369.822 12.7337 379.62 12.5047 383.726 12.2799C390.864 11.9192 396.516 11.8281 401.058 12.4885L321.718 90.1005Z",
    fill: "url(#paint5_linear_bow_button_432)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M401.672 89.0382C398.066 89.9596 393.719 90.4402 388.485 90.342C385.257 90.275 373.442 90.214 355.941 90.1664L418.031 29.4287C418.214 30.0699 418.392 30.7334 418.567 31.4201C421.154 41.6199 419.795 64.5487 417.972 73.0936L401.672 89.0382Z",
    fill: "url(#paint6_linear_bow_button_432)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220 18.7828C220 15.4691 222.686 12.7828 226 12.7828H414C417.313 12.7828 420 15.4691 420 18.7828V84.7828C420 88.0965 417.313 90.7828 414 90.7828H226C222.686 90.7828 220 88.0965 220 84.7828V18.7828Z",
    fill: "url(#paint7_linear_bow_button_432)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.521 24.7195C12.172 26.7176 11.882 30.5322 12.027 31.8037C12.172 33.0752 14.6364 33.2569 18.1156 32.5303C21.5948 31.8037 23.9143 30.1689 23.1894 27.4442C22.3196 23.448 19.1304 23.6296 16.521 24.7195ZM26.0888 28.1708C26.8136 21.6315 29.8579 21.2682 42.1801 23.2663C56.3868 25.6277 61.6056 25.4461 61.7506 26.7176C62.0405 28.8974 54.2123 29.079 44.6445 29.079C35.0767 29.079 25.7988 30.5322 26.0888 28.1708Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M409.093 17.0771C408.787 16.2663 409.017 15.2624 410.815 14.3744C418.694 9.8187 430.093 3.37118 431.391 17.4254C431.697 20.8231 431.734 23.3328 431.237 24.993C433.265 17.5799 417.278 15.8805 409.093 17.0771Z",
    fill: "url(#paint8_linear_bow_button_432)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M410.816 14.3766C418.312 10.0518 429.02 3.98927 431.126 15.5724C427.3 11.9432 418.81 13.604 412.27 14.8785C410.128 15.1875 409.555 16.1142 409.555 17.0022C409.402 17.0409 409.249 17.0409 409.096 17.0795C408.828 16.3073 409.019 15.3034 410.816 14.3766Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M431.239 24.9929C429.556 31.6726 414.525 21.518 410.165 18.4677C410.165 18.4677 409.4 17.8886 409.132 17.1164C417.279 15.8808 433.457 15.3789 431.239 24.9929Z",
    fill: "url(#paint9_radial)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M409.094 17.0775C411.236 16.7687 413.378 16.5756 415.52 16.4984C417.662 16.4212 419.842 16.4598 421.946 16.6914C423.016 16.8073 424.087 17.0003 425.12 17.232C426.153 17.5023 427.185 17.8498 428.142 18.3517C429.098 18.8536 429.977 19.51 430.551 20.4367C431.163 21.3247 431.431 22.4058 431.354 23.4869C431.316 24.0274 431.24 24.568 431.125 25.0699C430.972 25.5719 430.704 26.0738 430.322 26.4213C429.939 26.7688 429.404 26.9618 428.907 27.0777C428.371 27.1549 427.836 27.1549 427.3 27.1163C426.229 27.0004 425.197 26.6916 424.202 26.3441C423.208 25.9966 422.213 25.5719 421.219 25.1085C419.268 24.1819 417.394 23.1008 415.558 21.9811C413.722 20.8614 411.925 19.6644 410.127 18.4675C413.646 20.9386 417.279 23.2938 421.181 25.1858C422.137 25.6491 423.131 26.0738 424.164 26.4599C425.197 26.8074 426.229 27.1163 427.3 27.2321C427.836 27.3093 428.371 27.3093 428.907 27.1935C429.442 27.1163 429.977 26.8846 430.398 26.5371C430.819 26.151 431.087 25.6491 431.24 25.1471C431.393 24.6066 431.469 24.0661 431.469 23.5255C431.507 22.4444 431.24 21.3247 430.628 20.398C430.016 19.4714 429.136 18.815 428.18 18.3131C427.224 17.8111 426.191 17.4637 425.158 17.1934C424.126 16.9231 423.055 16.7687 421.984 16.6528C417.7 16.1895 413.34 16.4598 409.094 17.0775Z",
    fill: "#FF7E5D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408.444 18.5447C408.329 17.7339 408.674 16.7686 410.586 16.4984C417.012 15.1859 432.617 14.337 428.676 25.8428C427.183 30.2057 425.118 32.3678 423.014 32.7152C427.145 30.669 414.372 20.5912 408.444 18.5447Z",
    fill: "url(#paint10_linear_bow_button_432)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M428.522 26.1898C427.069 19.626 414.907 17.8494 408.979 17.772C408.787 17.772 408.634 17.772 408.481 17.772C408.673 17.1928 409.247 16.6909 410.547 16.4979C416.973 15.1854 432.578 14.3365 428.637 25.8423C428.598 25.9967 428.56 26.074 428.522 26.1898Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M422.978 32.754C416.361 33.6806 412.192 24.2597 408.865 19.7422C408.865 19.7422 408.521 19.2017 408.406 18.5453C414.373 20.5916 429.939 31.2868 422.978 32.754Z",
    fill: "url(#paint11_radial)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M408.444 18.5453C409.285 18.8542 410.127 19.2403 410.93 19.6264C411.733 20.0511 412.536 20.4758 413.34 20.9391C414.908 21.8658 416.438 22.8311 417.929 23.9121C419.421 24.9932 420.836 26.1129 422.175 27.3871C422.825 28.0049 423.437 28.6998 423.972 29.4334C424.24 29.8196 424.47 30.2057 424.584 30.6304C424.699 31.0551 424.699 31.557 424.431 31.9045C424.164 32.252 423.743 32.4451 423.322 32.5995C423.207 32.6381 423.093 32.6767 422.978 32.6767C422.863 32.7154 422.748 32.7153 422.634 32.7153C422.404 32.754 422.175 32.754 421.945 32.754C421.027 32.754 420.148 32.5223 419.306 32.1748C417.662 31.4412 416.285 30.1671 415.099 28.7771C412.689 25.9971 410.968 22.7152 408.826 19.7422C409.897 21.248 410.815 22.8311 411.81 24.3755C412.804 25.9199 413.837 27.4643 415.023 28.8543C416.208 30.2443 417.585 31.5184 419.268 32.2906C420.109 32.6767 421.027 32.8698 421.945 32.9084C422.175 32.9084 422.404 32.9084 422.634 32.8698C422.748 32.8698 422.863 32.8312 422.978 32.8312C423.093 32.7926 423.207 32.7926 423.322 32.754C423.743 32.6381 424.202 32.4065 424.508 32.0204C424.661 31.8273 424.737 31.5956 424.737 31.364C424.737 31.1323 424.699 30.9007 424.661 30.669C424.508 30.2057 424.278 29.8196 424.011 29.4334C423.475 28.6612 422.863 28.0049 422.175 27.3485C420.836 26.0743 419.383 24.9546 417.891 23.9121C416.399 22.8697 414.87 21.8658 413.263 20.9777C412.46 20.5144 411.657 20.0897 410.854 19.7036C410.127 19.2403 409.285 18.8542 408.444 18.5453Z",
    fill: "#FF805E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M410.201 16.1515C410.813 15.7268 411.195 14.916 410.392 13.4488C407.754 7.38684 399.227 -6.51322 392.15 3.7569C390.505 6.11207 389.701 8.19701 389.472 9.85725C390.429 2.05798 405.727 11.5567 410.201 16.1515Z",
    fill: "url(#paint12_linear_bow_button_432)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M392.34 3.48694C399.379 -6.2426 407.753 7.42576 410.391 13.4491C410.888 14.3757 410.888 15.0321 410.735 15.4954C407.446 10.1671 398.766 -0.644127 392.34 3.48694Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M389.473 9.85822C387.828 18.893 403.93 16.615 408.788 16.615C408.788 16.615 409.629 16.5764 410.203 16.1517C405.728 11.5571 391.576 -0.412093 389.473 9.85822Z",
    fill: "url(#paint13_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M409.017 14.9933C406.11 12.2134 403.012 9.62647 399.494 7.65733C397.734 6.69207 395.86 5.84264 393.833 5.72681C392.839 5.6882 391.768 5.95848 391.003 6.65347C390.238 7.34846 389.779 8.31373 389.511 9.27899C389.243 10.2443 389.167 11.3253 389.435 12.3292C389.664 13.3331 390.314 14.2211 391.117 14.8389C392.762 16.0744 394.827 16.4606 396.778 16.7308C400.756 17.2328 404.772 16.808 408.749 16.615C404.772 16.6922 400.756 17.0783 396.778 16.5764C394.827 16.3061 392.8 15.8814 391.194 14.6845C390.429 14.1053 389.817 13.2559 389.588 12.2906C389.358 11.3253 389.435 10.3215 389.702 9.35621C389.97 8.39094 390.391 7.46429 391.117 6.80791C391.844 6.15153 392.839 5.88125 393.833 5.91986C395.822 5.99708 397.696 6.84651 399.455 7.77317C401.215 8.73843 402.859 9.89674 404.427 11.0937C406.034 12.3292 407.564 13.6034 409.017 14.9933Z",
    fill: "url(#paint14_linear_bow_button_432)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M409.935 17.5034C410.432 16.9629 410.7 16.1521 409.438 15.0709C405.882 11.48 392.458 1.36361 391.156 12.2903C390.659 16.576 391.041 19.356 392.417 20.7074C389.473 15.3791 404.963 16.2291 409.935 17.5034Z",
    fill: "url(#paint15_linear_bow_button_432)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M391.117 12.7532C391.117 12.5988 391.155 12.4443 391.155 12.2513C392.457 1.32457 405.88 11.441 409.437 15.0319C410.278 15.7655 410.431 16.3447 410.278 16.8466C405.039 13.912 395.592 9.97341 391.117 12.7532Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M392.419 20.6685C395.861 24.4523 404.505 19.8963 409.019 18.1202C409.019 18.1202 409.554 17.8885 409.937 17.5024C404.964 16.2283 388.365 15.456 392.419 20.6685Z",
    fill: "url(#paint16_radial)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M409.937 17.5023C408.254 17.0776 406.533 16.8846 404.811 16.7301C403.09 16.5757 401.331 16.4985 399.61 16.5371C397.889 16.5757 396.129 16.6915 394.446 17.1162C394.026 17.2321 393.605 17.3479 393.222 17.541C392.84 17.734 392.419 17.9657 392.151 18.3132C391.999 18.4676 391.884 18.6993 391.846 18.931C391.807 19.1626 391.807 19.3943 391.846 19.6259C391.96 20.0893 392.19 20.4754 392.457 20.8229C392.955 21.3634 393.643 21.7882 394.332 22.0198C395.058 22.2515 395.785 22.3287 396.512 22.2901C398.003 22.2515 399.457 21.904 400.872 21.4793C402.287 21.0545 403.664 20.514 405.041 19.9348C406.418 19.3557 407.756 18.7379 409.095 18.1973C407.718 18.7379 406.38 19.317 405.003 19.8962C403.626 20.4368 402.249 20.9773 400.834 21.402C399.418 21.8268 397.965 22.1356 396.512 22.1743C395.785 22.1743 395.058 22.097 394.332 21.8654C393.643 21.6337 392.993 21.2476 392.496 20.7071C392.228 20.3596 391.999 19.9734 391.922 19.5873C391.807 19.1626 391.922 18.7379 392.228 18.429C392.496 18.1201 392.878 17.8885 393.261 17.6954C393.643 17.5024 394.064 17.3865 394.485 17.2707C396.167 16.846 397.889 16.7301 399.61 16.6915C401.331 16.6529 403.09 16.7301 404.811 16.846C406.494 16.9232 408.254 17.1162 409.937 17.5023Z",
    fill: "#FE7758"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M406.416 10.8612C409.17 8.7377 413.186 11.7495 413.186 11.7495C415.251 13.8731 408.098 17.1933 410.163 21.8267C410.163 21.8267 404.847 21.7878 403.394 17.7723C402.936 12.9074 406.416 10.8612 406.416 10.8612Z",
    fill: "url(#paint17_radial)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M413.186 11.7111C413.339 11.8656 413.454 12.0972 413.53 12.3289C413.569 12.5605 413.569 12.7922 413.492 13.0239C413.339 13.4872 413.109 13.8733 412.842 14.2594C412.306 15.0316 411.694 15.7265 411.12 16.4987C410.585 17.2709 410.087 18.1203 409.858 19.0469C409.743 19.5103 409.705 19.9736 409.743 20.4755C409.781 20.9388 409.934 21.4022 410.125 21.8269C409.743 20.9775 409.666 19.9736 409.934 19.0856C410.164 18.1975 410.661 17.3481 411.197 16.6145C411.732 15.8424 412.344 15.1474 412.88 14.3366C413.148 13.9505 413.377 13.5258 413.53 13.0625C413.607 12.8308 413.607 12.5992 413.53 12.3675C413.492 12.0972 413.339 11.8656 413.186 11.7111Z",
    fill: "#FE7757"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M394.864 4.8775C394.864 4.9547 394.826 5.0319 394.75 5.0705L394.711 5.03191C394.788 4.95471 394.826 4.9161 394.864 4.8775Z",
    fill: "#FE7959"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M394.903 4.91602L394.75 5.07043C394.827 4.99322 394.865 4.95462 394.903 4.91602Z",
    fill: "#FE7959"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M394.789 5.07048L394.713 5.0319L394.713 4.9933L394.789 5.07048Z",
    fill: "#FE7959"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M394.864 4.87726C394.826 4.91586 394.788 4.95447 394.711 5.03168L394.864 4.87726C394.902 4.91585 394.902 4.91585 394.864 4.87726Z",
    fill: "#FE7959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bow_button_432",
    x1: 211.986,
    y1: 12.7829,
    x2: 212.012,
    y2: 90.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237569,
    stopColor: "#FB6950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475138,
    stopColor: "#F98F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552486,
    stopColor: "#FB6950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E90202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bow_button_432",
    x1: 167.455,
    y1: 44.629,
    x2: 172.188,
    y2: 73.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bow_button_432",
    x1: 167.455,
    y1: 44.629,
    x2: 172.188,
    y2: 73.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bow_button_432",
    x1: 167.455,
    y1: 44.629,
    x2: 172.188,
    y2: 73.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bow_button_432",
    x1: 167.455,
    y1: 44.629,
    x2: 172.188,
    y2: 73.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_bow_button_432",
    x1: 167.455,
    y1: 44.629,
    x2: 172.188,
    y2: 73.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_bow_button_432",
    x1: 167.455,
    y1: 44.629,
    x2: 172.188,
    y2: 73.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_bow_button_432",
    x1: 410.198,
    y1: 8.07596,
    x2: 309.77,
    y2: 75.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_bow_button_432",
    x1: 432.215,
    y1: 17.3917,
    x2: 409.174,
    y2: 14.8134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(420.16 21.4023) rotate(-173.503) scale(8.81027 8.89183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_bow_button_432",
    x1: 427.668,
    y1: 27.1031,
    x2: 409.926,
    y2: 15.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410.732 27.724) rotate(-163.365) scale(11.1737 11.2626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00980392,
    stopColor: "#FF616E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952373,
    stopColor: "#FB4C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#F11516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    stopColor: "#ED0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#D00200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    stopColor: "#A60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    stopColor: "#A50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#7D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#650000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#5C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_bow_button_432",
    x1: 391.903,
    y1: 3.75515,
    x2: 411.633,
    y2: 13.6837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.458 13.421) rotate(27.1429) scale(8.44182 8.48873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#610000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_bow_button_432",
    x1: 409.118,
    y1: 15.374,
    x2: 389.4,
    y2: 9.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6713,
    stopColor: "#FF704C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    stopColor: "#FF7C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF805E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_bow_button_432",
    x1: 390.373,
    y1: 14.3376,
    x2: 407.182,
    y2: 12.8241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408.929 27.8076) rotate(169.956) scale(16.6079 16.7561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00980392,
    stopColor: "#FF616E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952373,
    stopColor: "#FB4C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#F11516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    stopColor: "#ED0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#D00200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    stopColor: "#A60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#980000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#700000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9247,
    stopColor: "#580000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#4F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(416.342 3.458) rotate(-146.777) scale(18.5547 18.6276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "#F51911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6485,
    stopColor: "#FF453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#FF876E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8314,
    stopColor: "#F63636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BA1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9758,
    stopColor: "#890D01"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton432);
export default __webpack_public_path__ + "static/media/button-432.899a3996.svg";
export { ForwardRef as ReactComponent };